/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

export const userSettingsResponseDtoSchema = z.object({ "appId": z.string().uuid().nullish(), "env": z.string().nullish(), "name": z.string().nullish(), "userId": z.string().uuid().nullish(), "value": z.string().nullish() });
export type UserSettingsResponseDto = z.infer<typeof userSettingsResponseDtoSchema>;
